import axios from 'axios'
import { instance } from '../lib/api'
import Constants from '../utils/CommonConstants'
import { API_FAIL } from './dashboard'
import { LOAD_COUNT_DECREMENT, LOAD_COUNT_INCREMENT } from './loading'

export const TBU_DASHBOARD = 'TBU_DASHBOARD'

export const getTbuDashboard = (agentId, childList) => {
  const childListIds = Object.keys(childList)
    .map(key => childList[key].id)
    .join()
  return dispatch => {
    let urls = []
    Constants.ticketingCategories.forEach(category => {
      urls.push({
        url: `/api/v1/ticket/search?category_id=${category.id}&assignee_id=${childListIds}&status_is_open=1`,
        label: `Pending ${category.name} Requests`
      })
      urls.push({
        url: `/api/v1/ticket/search?category_id=${category.id}&assignee_id=${childListIds}`,
        label: `Total ${category.name} Requests`
      })
    })

    dispatch({
      type: LOAD_COUNT_INCREMENT,
      message: 'Fetching TBU dashboard details.'
    })

    axios
      .all(
        urls.map(item => {
          return instance({
            url: item.url,
            method: 'GET'
          })
        })
      )
      .then(
        response => {
          const data = response.map((resp, index) => ({
            count: resp.data.count,
            url: resp.data.page_url,
            label: urls[index].label
          }))
          dispatch({
            type: TBU_DASHBOARD,
            data
          })
        },
        error => {
          dispatch({
            type: API_FAIL
          })
        }
      )
      .finally(() => {
        dispatch({
          type: LOAD_COUNT_DECREMENT
        })
      })
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/tbuDashboard.js
 **/